import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import { getCommercialAgents } from '../../data/CommercialAgents/actions';
import { Add as AddIcon } from '@material-ui/icons/index';

class CommercialAgent extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        getCommercialAgents: PropTypes.func.isRequired,
        commercialAgents: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshCommercialAgent();
    }

    refreshCommercialAgent = () => {
        const { getCommercialAgents } = this.props;
        this.setState({ loading: true });
        return getCommercialAgents()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `commercialAgent/detail/${rowData.id}` });
    };

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`${history.environment}.commercialAgent.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshCommercialAgent
                }
            ]
        };
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('commercialAgentDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderData = memoizeOne(commercialAgents => {
        let results = [];

        commercialAgents.map((CA, CAId) => {
            results.push({
                id: CAId,
                email: CA.get('email'),
                firstname: CA.get('firstname'),
                lastname: CA.get('lastname'),
                city: CA.get('city'),
                phone: CA.get('phone'),
                society: CA.get('society'),
                language: Translator.translate(`general.table.column.languages.${CA.get('language')}`)
            });
        });

        return results;
    });

    renderColumns = memoizeOne(profile => {
        const { history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('commercialAgentDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.lastname'),
                name: 'lastname'
            },
            {
                title: Translator.translate('general.table.column.firstname'),
                name: 'firstname'
            },
            {
                title: Translator.translate('general.table.column.city'),
                name: 'city'
            },
            {
                title: Translator.translate('general.table.column.phone'),
                name: 'phone'
            },
            {
                title: Translator.translate('general.table.column.society'),
                name: 'society'
            },
            {
                title: Translator.translate('general.table.column.language'),
                name: 'language'
            }
        ];
    });

    render() {
        const { loading } = this.state;
        const { profile, commercialAgents, history } = this.props;

        return (
            <FHETable
                idTable="commercialAgentList"
                columns={this.renderColumns(profile)}
                data={this.renderData(commercialAgents)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`${history.environment}.commercialAgent.table.title`)}
                emptyDataSourceMessage={Translator.translate(`${history.environment}.commercialAgent.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    return {
        profile: state.data.user,
        commercialAgents: state.environments[history.environment].data.CommercialAgents.get('list'),
        initialized: state.environments[history.environment].data.CommercialAgents.get('initialized')
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getCommercialAgents }, dispatch)
    )(CommercialAgent)
);



// WEBPACK FOOTER //
// ./environments/simulationenr/scenes/CommercialAgent/index.js